import React from 'react';
import { Layout, pageTypes } from 'gatsby-theme-apollo';
import Footer from './footer';
import GameContent from './content';
import Post from '../posts/post';

const GuideBuilderPage = ({ location, pageContext }) => {
  const pageType = pageTypes.GUIDE_BUILDER;
  const { gameName } = pageContext;

  const pageTitle = `${gameName} Guide Builder`;

  return (
    <Layout location={location} title={pageTitle} gameName={gameName} pageType={pageType}>
      <GameContent header={pageTitle} largeHeadline headerSolidBackground pop>
        <Post builderModeByDefault />
      </GameContent>
      <Footer />
    </Layout>
  );
};

export default GuideBuilderPage;
